import React, { useRef, useState, useEffect } from "react";
import PT from "prop-types";
import * as S from "./styled";
import { TextField } from "_c/form/Field";
import { useForm, FormContext } from "react-hook-form";
import { ProgressEmitter } from "_c/GlobalProgress/emitter";
import { Translate } from "@/i18n/utils";
import { useNotify } from "@/hooks/useNotify";
import { Button } from "_c/button";
import Info from "_c/atoms/Info";
import moment from "moment";
import { analyticsAction } from "@/utils/analytics";
import Socials from "../socials";
import { useTimezone } from "@/hooks/useTimezone";

const WAIT_DUR = { seconds: 10 };

let _wait;
const FinalStepPhone = (props) => {
  const timezone = useTimezone();
  const interval = useRef();
  const [now, setNow] = useState(moment());
  const [wait, setWait] = useState(() => {
    if (!_wait) {
      const time = moment().add(WAIT_DUR);
      _wait = time;
      return time;
    } else {
      return _wait;
    }
  });
  const [isRequesting, setIsRequesting] = useState(false);
  const { notify, notifyError } = useNotify();
  const methods = useForm({
    defaultValues: {
      code: "",
    },
  });
  const code = methods.watch("code");
  useEffect(() => {
    interval.current = setInterval(() => {
      setNow(moment());
    }, 1000);
    return () => {
      if (interval.current) {
        clearInterval(interval.current);
      }
    };
  }, []);
  useEffect(() => {
    analyticsAction({
      category: "reg",
      action: "confirmation_screen",
    });
  }, []);
  const canRequestCode = wait.isBefore(now);
  const onSubmit = async ({ code }) => {
    const finalCode = code.trim();
    if (!finalCode) return;
    try {
      ProgressEmitter.start();
      await props.submitPhoneVerificationCode(finalCode);
      analyticsAction({
        category: "login",
        action: "sms_code_submit_ok",
      });
    } catch (e) {
      console.error(e);
      notifyError(Translate.serverError(props.t, e));
      analyticsAction({
        category: "login",
        action: "sms_code_submit_err",
      });
    } finally {
      ProgressEmitter.end();
    }
  };
  const onRequest = async () => {
    setIsRequesting(true);
    try {
      ProgressEmitter.start();
      await props.requestPhoneVerificationCode();
      analyticsAction({
        category: "login",
        action: "sms_code_req_ok",
      });
      notify(props.t("login:sms_code_sent"));
      const next = moment().add(WAIT_DUR);
      _wait = next;
      setWait(next);
    } catch (e) {
      console.error(e);
      notifyError(Translate.serverError(props.t, e));
      analyticsAction({
        category: "login",
        action: "sms_code_req_err",
      });
    } finally {
      setIsRequesting(false);
      ProgressEmitter.end();
    }
  };
  return (
    <S.Wrap>
      <Info cta>{props.t("login:sms_code_tip", { phone: props.phone })}</Info>
      <FormContext {...methods}>
        <form onSubmit={methods.handleSubmit(onSubmit)}>
          <TextField
            autoFocus
            autoComplete="off"
            name="code"
            style={{
              width: "90px",
            }}
            id="reg-phone-confirm"
            t={props.t}
            label={props.t("login:sms_code") + ":"}
          />
          <div style={{ textAlign: "center" }}>
            <div>
              <Button
                disabled={
                  !code.trim() || methods.formState.isSubmitting || isRequesting
                }
                type="submit"
                small
                greenish
              >
                {props.t("common:send")}
              </Button>
            </div>
            <Button
              disabled={
                isRequesting ||
                methods.formState.isSubmitting ||
                !canRequestCode
              }
              onClick={onRequest}
              type="button"
              small
              style={{
                marginTop: "15px",
              }}
            >
              {canRequestCode ? (
                <span>{props.t("login:request_sms_code")}</span>
              ) : (
                <span>{moment(wait.clone().diff(now)).format("mm:ss")}</span>
              )}
            </Button>
          </div>
        </form>
      </FormContext>
      <div style={{ marginTop: "20px" }}>
        <Socials
          action={"reg"}
          isMaster={props.isMaster}
          isSaloonOwner={props.isSaloonOwner}
          isClient={props.isClient}
          locale={props.locale}
          timezone={timezone}
        />
      </div>
    </S.Wrap>
  );
};
FinalStepPhone.propTypes = {
  phone: PT.string.isRequired,

  t: PT.func.isRequired,
  requestPhoneVerificationCode: PT.func.isRequired,
  submitPhoneVerificationCode: PT.func.isRequired,
};

export default FinalStepPhone;
